(function () {
  var OPEN_CLASS = 'l4-pair-modal--open';
  var BODY_LOCK_CLASS = 'l4-pair-modal-body-lock';
  var CLOSE_MS = 380;

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function pauseModalVideos(modal) {
    if (!modal) return;
    modal.querySelectorAll('.l4-pair-modal__video').forEach(function (video) {
      try {
        if (window.L4DeferredVideo) window.L4DeferredVideo.pause(video);
        else video.pause();
        video.currentTime = 0;
      } catch (e) {}
    });
  }

  function playModalVideos(modal) {
    if (!modal) return;
    modal.querySelectorAll('.l4-pair-modal__video').forEach(function (video) {
      try {
        if (window.L4DeferredVideo) {
          video.dataset.videoShouldPlay = 'true';
          window.L4DeferredVideo.prepare(video);
        }
        if (video.readyState > 0) video.currentTime = 0;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    });
  }

  function finalizeClose(modal) {
    modal.hidden = true;
    document.body.classList.remove(BODY_LOCK_CLASS);

    if (modal._l4PairTrigger) {
      modal._l4PairTrigger.setAttribute('aria-expanded', 'false');
      modal._l4PairTrigger.focus();
      modal._l4PairTrigger = null;
    }
  }

  function openModal(modal, trigger) {
    if (!modal || modal.classList.contains(OPEN_CLASS)) return;

    modal.hidden = false;

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      modal._l4PairTrigger = trigger;
    }

    document.body.classList.add(BODY_LOCK_CLASS);

    if (prefersReducedMotion()) {
      modal.classList.add(OPEN_CLASS);
      playModalVideos(modal);
      var closeBtn = modal.querySelector('.l4-pair-modal__close');
      if (closeBtn) closeBtn.focus();
      return;
    }

    /* 双 rAF：先渲染初始态，再过渡到打开态 */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add(OPEN_CLASS);
        playModalVideos(modal);
        var closeBtn = modal.querySelector('.l4-pair-modal__close');
        if (closeBtn) closeBtn.focus();
      });
    });
  }

  function closeModal(modal) {
    if (!modal || !modal.classList.contains(OPEN_CLASS)) return;

    pauseModalVideos(modal);
    modal.classList.remove(OPEN_CLASS);

    if (prefersReducedMotion()) {
      finalizeClose(modal);
      return;
    }

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      finalizeClose(modal);
    }

    var panel = modal.querySelector('.l4-pair-modal__panel');
    var timer = window.setTimeout(finish, CLOSE_MS);

    if (panel) {
      panel.addEventListener(
        'transitionend',
        function handler(e) {
          if (e.target !== panel) return;
          if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
          window.clearTimeout(timer);
          panel.removeEventListener('transitionend', handler);
          finish();
        }
      );
    }
  }

  function closeAll() {
    document.querySelectorAll('[data-l4-pair-modal].' + OPEN_CLASS).forEach(closeModal);
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    closeAll();
  }

  function onClick(e) {
    var openBtn = e.target.closest('[data-l4-pair-modal-open]');
    if (openBtn) {
      e.preventDefault();
      var id = openBtn.getAttribute('data-l4-pair-modal-open');
      var modal = id ? document.getElementById(id) : null;
      if (modal) openModal(modal, openBtn);
      return;
    }

    var closeEl = e.target.closest('[data-l4-pair-modal-close]');
    if (closeEl) {
      e.preventDefault();
      var modalClose = closeEl.closest('[data-l4-pair-modal]');
      if (modalClose) closeModal(modalClose);
    }
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);

  document.addEventListener('shopify:section:load', function () {});
})();
